import { getScopeRoot, getScopeForIsProjectOverlay } from '../scope/scope'

let pixelateObserver
let pixelateItems
// Remove the single animated filter - we'll create individual ones per image

var i = function () {
	if (document.body.classList.contains('lazyload-pixelated-animated') && document.body.classList.contains('no-touchdevice') && 'IntersectionObserver' in window) {
		window.laytheme.on('newpageshown', function (layoutObj, type, obj, isProjectOverlayObj) {
			let root = getScopeRoot(getScopeForIsProjectOverlay(isProjectOverlayObj))
			let isScrollSliderActive = false
			if(window.scrollSlider != undefined && window.scrollSlider.isActiveHere != undefined){
				isScrollSliderActive = window.scrollSlider.isActiveHere()
			}
			// Remove the single filter creation - we'll create individual ones per image

			let options = {
				threshold: 0,
				rootMargin: '0px 0px -100px 0px', // Animation starts when 100px of element is already shown
			}
			pixelateObserver = new IntersectionObserver(pixelateCallback, options)

			// Select all lazyload images that should have the animated pixelation effect
			pixelateItems = root ? root.querySelectorAll('img.lazyload') : []

			// Remove the initial filter application since we'll create individual filters
			if(!isScrollSliderActive){
				// Observe elements
				pixelateItems.forEach((el) => {
					pixelateObserver.observe(el)
				})
			}
		})

		window.laytheme.on('searchresultshown', function () {
			// Get search result images
			let searchResultItems = document.querySelectorAll('#search-results-region img.lazyload')
			
			// Observe the new search result images
			searchResultItems.forEach((el) => {
				pixelateObserver.observe(el)
			})
		})

		window.laytheme.on('overlayshown_animation_ended', function () {
			// Get search result images
			let itemsInOverlay = document.querySelectorAll('.lay-overlay img.lazyload')
			
			// Observe the new search result images
			itemsInOverlay.forEach((el) => {
				pixelateObserver.observe(el)
			})
		})
	}
}

var createAnimatedFilter = function (imageElement) {
	// Find the SVG container's <defs>. PHP wraps filters in <defs> so they
	// stay definitions-only (and never paint); dynamic filters created here
	// must follow the same rule or iOS Safari occasionally renders them as
	// a visible black rectangle.
	var svg = document.querySelector('.svg-filter-wrap')
	if (!svg) {
		console.error('SVG filter container not found!')
		return null
	}
	var defs = svg.querySelector('defs')
	if (!defs) {
		// Backward-compat for the case where header.php hasn't been updated
		// yet — fall back to a freshly-created <defs> so the filter still
		// hides correctly.
		defs = document.createElementNS('http://www.w3.org/2000/svg', 'defs')
		svg.appendChild(defs)
	}

	// Create unique animated filter for this specific image
	var filterId = 'pixelateAni_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9)

	var filter = document.createElementNS('http://www.w3.org/2000/svg', 'filter')
	filter.setAttribute('id', filterId)
	filter.setAttribute('x', '0')
	filter.setAttribute('y', '0')
	filter.setAttribute('width', '100%')
	filter.setAttribute('height', '100%')

	// Create the filter elements
	var feFlood = document.createElementNS('http://www.w3.org/2000/svg', 'feFlood')
	feFlood.setAttribute('x', '1')
	feFlood.setAttribute('y', '1')
	feFlood.setAttribute('height', '1')
	feFlood.setAttribute('width', '1')

	var feComposite = document.createElementNS('http://www.w3.org/2000/svg', 'feComposite')
	feComposite.setAttribute('id', 'animated-composite-' + filterId)
	feComposite.setAttribute('in2', 'SourceGraphic')
	feComposite.setAttribute('operator', 'in')
	feComposite.setAttribute('width', '24') // Start with most pixelated
	feComposite.setAttribute('height', '24')

	var feTile = document.createElementNS('http://www.w3.org/2000/svg', 'feTile')
	feTile.setAttribute('result', 'tiled')

	var feComposite2 = document.createElementNS('http://www.w3.org/2000/svg', 'feComposite')
	feComposite2.setAttribute('in', 'SourceGraphic')
	feComposite2.setAttribute('in2', 'tiled')
	feComposite2.setAttribute('operator', 'in')

	var feMorphology = document.createElementNS('http://www.w3.org/2000/svg', 'feMorphology')
	feMorphology.setAttribute('id', 'animated-morphology-' + filterId)
	feMorphology.setAttribute('operator', 'dilate')
	feMorphology.setAttribute('radius', '12') // Start with most pixelated

	// Append elements to filter
	filter.appendChild(feFlood)
	filter.appendChild(feComposite)
	filter.appendChild(feTile)
	filter.appendChild(feComposite2)
	filter.appendChild(feMorphology)

	// Append filter into <defs> (not directly into SVG root) so iOS Safari
	// treats it as a definition and never paints it as a visible element.
	defs.appendChild(filter)

	// Return filter reference for this specific image
	return {
		id: filterId,
		composite: feComposite,
		morphology: feMorphology,
		element: filter, // Store the filter element for cleanup
	}
}

let pixelateCallback = (entries, observer) => {
	entries.forEach((entry) => {
		if (entry.isIntersecting) {
			// Start the animated pixelation effect (can restart)
			startPixelateAnimation(entry.target)
		}
	})
}

var startPixelateAnimation = function (element) {
	if (element.classList.contains('pixelate-animation-started')) {
		return
	}

	// Create individual animated filter for this image
	var animatedFilter = createAnimatedFilter(element)
	if (!animatedFilter) {
		console.error('Failed to create animated filter!')
		return
	}

	element.classList.add('pixelate-animation-started')

	// Store the filter reference on the element for cleanup
	element._pixelateFilter = animatedFilter

	// Reset filter to initial pixelated state
	animatedFilter.composite.setAttribute('width', '24')
	animatedFilter.composite.setAttribute('height', '24')
	animatedFilter.morphology.setAttribute('radius', '12')

	// Apply the filter to the element
	element.style.filter = 'url(#' + animatedFilter.id + ')'

	// Animation parameters
	var duration = 350 // in ms
	var startTime = Date.now()
	var startWidth = 24
	var startHeight = 24
	var startRadius = 12
	var endWidth = 2
	var endHeight = 2
	var endRadius = 1

	// Easing function: starts slow, accelerates towards the end
	var easeOutCubic = function (t) {
		return 1 - Math.pow(1 - t, 3)
	}

	var animate = function () {
		var elapsed = Date.now() - startTime
		var progress = Math.min(elapsed / duration, 1)
		var easedProgress = easeOutCubic(progress)

		// Calculate current values
		var currentWidth = startWidth + (endWidth - startWidth) * easedProgress
		var currentHeight = startHeight + (endHeight - startHeight) * easedProgress
		var currentRadius = startRadius + (endRadius - startRadius) * easedProgress

		// Update filter values
		animatedFilter.composite.setAttribute('width', currentWidth)
		animatedFilter.composite.setAttribute('height', currentHeight)
		animatedFilter.morphology.setAttribute('radius', currentRadius)

		if (progress < 1) {
			// Continue animation
			requestAnimationFrame(animate)
		} else {
			// Animation completed

			// Remove the filter from the element
			element.style.filter = ''

			// Clean up the filter from the SVG
			if (animatedFilter.element && animatedFilter.element.parentNode) {
				animatedFilter.element.parentNode.removeChild(animatedFilter.element)
			}

			// Remove the stored reference
			delete element._pixelateFilter
		}
	}

	// Start the animation
	requestAnimationFrame(animate)
}

var pixelate_animated_effect_controller = {
	i: i,
}

export default pixelate_animated_effect_controller
